import { firstError, requestIdOf } from '../utils/format.js'

/**
 * Error banner used throughout the app.
 *
 * Displays the most specific error message we can extract, plus the
 * request id echoed by the server (X-Request-ID). Support staff ask
 * patients to read this id back so they can pull the exact log line,
 * audit row, and response that failed.
 *
 * The id is click-to-select so patients can paste it into a ticket.
 */
export default function ErrorBanner({ error, onRetry }) {
  if (!error) return null
  const rid = requestIdOf(error)
  return (
    <div className="rounded-md border border-rose-200 bg-rose-50 text-rose-800 px-3 py-2 text-sm flex items-start justify-between gap-2">
      <div className="flex-1">
        <div>{firstError(error)}</div>
        {rid && (
          <div
            className="mt-1 text-[11px] text-rose-600/80 font-mono select-all"
            title="Quote this id when contacting support"
          >
            Support reference: {rid}
          </div>
        )}
      </div>
      {onRetry && (
        <button onClick={onRetry} className="text-xs underline shrink-0">Retry</button>
      )}
    </div>
  )
}
